/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc 確認メッセージ
 *
 * @author genka
 * @copyright Copyright 2019 TechMatrix Corporation, Inc. All rights reserved.
 */
<script>
import FcQuestionMessage from './FcQuestionMessage'
import FcMessageUtil from '@/utils/FcMessageUtil'
import MessageInfoConst from '@/constants/MessageInfoConst'

export default {
  mixins: [FcQuestionMessage],
  name: 'FcConfirmMessage',
  computed: {
    /**
     * messageClass のオーバーライド
     */
    messageClass() {
      return 'fc-confirm-message ' + 'fc-text-message ' + FcMessageUtil.messageDistributionClass(this.messageInfo)
    },
    /**
     * answerList のオーバーライド
     */
    answerList() {
      if (this.messageInfo.messageType === MessageInfoConst.MESSAGE_TYPE_SWITCH_CONFIRM) {
        return this.$config.switchConfirmMessage.answerList
      } else {
        return this.$config.confirmMessage.answerList
      }
    }
  },
  methods: {
    /**
     * getSendAnswerMessageByAnswerInfo のオーバーライド
     */
    getSendAnswerMessageByAnswerInfo(answerInfo) {
      let result = {
        messageText: answerInfo.label,
        confirmType: answerInfo.confirmType
      }
      if (answerInfo.waitChatReceive) {
        result.messageOption = '{"waitChatReceive":true}'
      }
      return result
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/chatWindow/chatMain/message/FcConfirmMessage.vue